import React from "react";
import { StyledManagementFooter } from "./ManagementFooter.styled";
import {
  Button,
  ButtonVariants,
} from "../../../../components/core/Button/Button";
import { ReactComponent as EditIcon } from "../../../../icons/pencil.svg";
import { ReactComponent as CancelIcon } from "../../../../icons/close.svg";
import { ReactComponent as SaveIcon } from "../../../../icons/save.svg";
import {
  CANCEL_LABEL,
  EDIT_LABEL,
  SAVE_LABEL,
} from "../../../../constants/Dictionary";

export type ManagementFooterProps = {
  isEditable: boolean;
  disabledSave: boolean;
  toggleEdit: () => void;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ManagementFooter = ({
  isEditable,
  toggleEdit,
  disabledSave,
  onCancel,
  onConfirm,
}: ManagementFooterProps) => {
  return (
    <StyledManagementFooter>
      {isEditable && (
        <>
          <Button
            label={`${CANCEL_LABEL}`}
            icon={<CancelIcon />}
            onClick={onCancel}
            variant={ButtonVariants.SECONDARY}
          />
          <Button
            label={SAVE_LABEL}
            icon={<SaveIcon />}
            onClick={onConfirm}
            disabled={disabledSave}
          />
        </>
      )}
      {!isEditable && (
        <Button
          label={EDIT_LABEL}
          icon={<EditIcon />}
          onClick={toggleEdit}
          type="button"
        />
      )}
    </StyledManagementFooter>
  );
};
